export const durationToUnit = (seconds: number): string => {
  if (seconds === 86400) return 'Day';
  if (seconds === 3600) return 'Hour';
  if (seconds === 60) return 'Minute';
  return 'Second';
};

export const unitToDuration = (unit: string): number => {
  if (unit === 'Day') return 86400;
  if (unit === 'Hour') return 3600;
  if (unit === 'Minute') return 60;
  return 1;
};
